import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/reports/map");

export const Route = createFileRoute("/reports/map")({
  head: () => ({
    meta: [
      { title: "Network map — LevelLoad" },
      { name: "description", content: "Network map — LevelLoad transport planning." },
      { property: "og:title", content: "Network map — LevelLoad" },
      { property: "og:description", content: "Network map — LevelLoad transport planning." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
